
const ArticleCollection = function(element) {
    this.element = $(element);
    this.add = this.element.find('[data-add-line]');
    this.tbody = this.element.find('table tbody');

    this.add.on('form-success.modal', (event, response) => {
        let row = this.initRow();
        this.updateRow(row, response);
    });

    this.tbody.on('click', '[data-delete]', event => {
        $(event.currentTarget).closest('tr').remove();
    });

    this.tbody.on('before-load.modal', '[data-edit]', (event, requestData) => {
        this.setEditData($(event.currentTarget).closest('tr'), requestData)
    });
    this.tbody.on('form-success.modal', '[data-edit]', (event, response) => {
        this.updateRow($(event.currentTarget).closest('tr'), response);
    });

    this.tbody.on('change keyup', 'input', (event, response) => {
        this.updateValues($(event.currentTarget).closest('tr'), response);
    });
};

$.extend(ArticleCollection.prototype, {
    initRow: function() {
        let prototype = this.element.attr('data-prototype'),
            name = 0;

        // Find max name
        this.element.find('[data-name]').each(function() {
            let n = parseInt($(this).attr('data-name'));

            if (n >= name) {
                name = n + 1;
            }
        });

        prototype = prototype.replace(/__name__/g, name);

        return $(prototype).appendTo(this.tbody);
    },

    updateRow: function(row, data) {
        let prixUnitaire = data.prixUnitaire / 100,
            quantiteUnitaire = data.quantiteUnitaire,
            totalUnitaire = data.totalUnitaire / 100,
            quantite = data.quantite,
            prix = data.prix / 100,
            total = quantite * prix
        ;

        let quantiteLabel = quantiteUnitaire.toString(),
            prixLabel = NumberFormatter.formatMoney(prixUnitaire, ' €');

        if (!data.isKGS) {
            quantiteLabel += ' (' + quantite + ' KGS)';
            prixLabel += ' (' + NumberFormatter.formatMoney(prix, ' €') + ' / KGS)';
        }

        row.attr('data-ligne-kgs', data.isKGS ? '1' : '0');

        row.find('[name$="\[famille\]"]').val(data.famille.id);
        row.find('[data-famille]').text(data.famille.designation);

        row.find('[name$="\[origine\]"]').val(data.origine ? data.origine.id : '');
        row.find('[data-origine]').text(data.origine ? data.origine.designation : '-');

        row.find('[name$="\[calibre\]"]').val(data.calibre ? data.calibre.id : '');
        row.find('[data-calibre]').text(data.calibre ? data.calibre.designation : '-');

        row.find('[name$="\[variete\]"]').val(data.variete ? data.variete.id : '');
        row.find('[data-variete]').text(data.variete ? data.variete.designation : '-');

        row.find('[name$="\[qualite\]"]').val(data.qualite ? data.qualite.id : '');
        row.find('[data-qualite]').text(data.qualite ? data.qualite.designation : '-');

        row.find('[name$="\[ratioQuantitePoids\]"]').val(data.ratioQuantitePoids);
        row.find('[name$="\[quantiteUnitaire\]"]').val(quantiteUnitaire);
        row.find('[name$="\[quantite\]"]').val(quantite);
        row.find('[data-quantite]').text(quantiteLabel);

        row.find('[name$="\[uniteVente\]"]').val(data.uniteVente);
        row.find('[data-unite-vente]').text(data.uniteVente);

        row.find('[name$="\[prixUnitaire\]"]').formatMoney(prixUnitaire);
        row.find('[name$="\[prix\]"]').formatMoney(prix);
        row.find('[data-prix-unitaire]').text(prixLabel);

        row.find('[name$="\[tauxTVA\]"]').val(data.tauxTVA);
        row.find('[name$="\[totalHT\]"]').formatMoney(totalUnitaire);
    },

    updateValues: function(row) {
        // Refresh total HT
        let quantiteUnitaire = row.find('[name$="\[quantiteUnitaire\]"]').parseInt(),
            prixUnitaire = row.find('[name$="\[prixUnitaire\]"]').parseMoney(),
            totalHT = quantiteUnitaire * prixUnitaire;

        row.find('[name$="\[totalHT\]"]').formatMoney(totalHT);

        if ('1' === row.attr('data-ligne-kgs')) {
            row.find('[name$="\[quantite\]"]').val(quantiteUnitaire);
            row.find('[name$="\[prix\]"]').formatMoney(prixUnitaire);
        } else {
            // Refresh champs KGS
            let ratio = row.find('[name$="\[ratioQuantitePoids\]"]').parseFloat();
            let quantite = Math.ceil(quantiteUnitaire * ratio),
                prix = Math.ceil(totalHT * 100. / quantite) / 100.;

            row.find('[name$="\[quantite\]"]').val(quantite);
            row.find('[name$="\[prix\]"]').formatMoney(prix);
        }
    },

    setEditData: function(row, requestData) {
        requestData.famille = row.find('[name$="\[famille\]"]').val();
        requestData.origine = row.find('[name$="\[origine\]"]').val();
        requestData.calibre = row.find('[name$="\[calibre\]"]').val();
        requestData.variete = row.find('[name$="\[variete\]"]').val();
        requestData.qualite = row.find('[name$="\[qualite\]"]').val();
        requestData.designation = row.find('[name$="\[designation\]"]').val();
        requestData.quantiteUnitaire = row.find('[name$="\[quantiteUnitaire\]"]').val();
        requestData.prixUnitaire = row.find('[name$="\[prixUnitaire\]"]').parseFloat() * 100;
    }
});

const articleCollection = () => {
    const selector = 'div[data-article-collection]';

    $(document).arrive(selector, {
        existing: true
    }, function() {
        new ArticleCollection(this);
    });
};

export { articleCollection }


// WEBPACK FOOTER //
// ./js/form/articleCollection.js